import { YayoyakiFormatter } from '@taxdown/kami-sama/dist/kamiSama/yayoyakiFormatter';

export const parsePriceFormat = (price: number, withoutFormat?: boolean): string => {
  const priceString = price.toString();
  const getDecimals = priceString.slice(-2);
  const priceWithOutDecimals = priceString.slice(0, -2);
  const finalPrice = `${priceWithOutDecimals}.${getDecimals}`;
  return withoutFormat ? finalPrice : YayoyakiFormatter.formatAmountMxn(Number(finalPrice));
};
